export function executeActivation(event, act) {
    act.action && act.action(event, act.menuButton);
}
